export default {
    notifications: [],
    notificationInfo: {
        totalFeeds: 0,
        unread: {
            post: 0,
            comment: 0,
            settle: 0,
            'comment-reply': 0,
        }
    }
}
